// extracted by mini-css-extract-plugin
module.exports = {"filterDropdown":"antd-pro-containers-knowledge-base-category-all-styles-filterDropdown","btn":"antd-pro-containers-knowledge-base-category-all-styles-btn"};